
























import Vue from "vue";
import { mapState } from "vuex";
import TestCaseStatus from "@/components/testcase/Status.vue";

export default Vue.extend({
  data() {
    return {
      selected: []
    };
  },
  computed: mapState(["testCases", "executions"]),
  methods: {
    executeSelected() {
      this.$store.dispatch("createExecution", this.selected);
    },
    formatDate(date: any) {
      return new Date(date.seconds * 1000).toLocaleString();
    }
  },
  components: {
    TestCaseStatus
  }
});
